export interface NotificationModel {
  id: number;
  title: string;
  body: string;
  type: NotificationType;
  link?: string;
  createdAt: string;
  readAt?: string;
  icon?: string;
  iconClass?: string;
  route?: string;
}

export enum NotificationType {
  REQUEST_EXPIRED = 'REQUEST_EXPIRED',
  NEW_CONTACT_REQUEST = 'NEW_CONTACT_REQUEST',
  NEW_QUOTE_REQUEST = 'NEW_QUOTE_REQUEST',
  QUOTE_INTEREST = 'QUOTE_INTEREST',
  BILLING = 'BILLING',
  REVIEW = 'REVIEW',
  PAYMENT = 'PAYMENT',
  SYSTEM = 'SYSTEM',
  GENERAL = 'GENERAL',
  PARTNER_UPDATED = 'PARTNER_UPDATED',
  PARTNER_CREATED = 'PARTNER_CREATED',
  NEW_REVIEW = 'NEW_REVIEW',
  NEW_SUPPORT_REQUEST = 'NEW_SUPPORT_REQUEST',
  // Evento tecnico solo-WebSocket (mai persistito come notifica): è cambiato il numero di
  // richieste di preventivo disponibili in zona. Niente toast/suono/campanella.
  AVAILABLE_QUOTES_CHANGED = 'AVAILABLE_QUOTES_CHANGED',
  // Evento tecnico solo-WebSocket per gli operatori Support (mai persistito): una richiesta è
  // uscita dalla lista Support perché il paziente l'ha verificata. Simmetrico di NEW_SUPPORT_REQUEST.
  SUPPORT_REQUEST_RESOLVED = 'SUPPORT_REQUEST_RESOLVED',
}
